var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftMiningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -2.139 0 -4.277 -0.551 -6.185 -1.653 L 10.553 72.03 c -3.815 -2.202 -6.186 -6.307 -6.186 -10.713 V 28.683 c 0 -4.405 2.37 -8.51 6.186 -10.714 L 38.815 1.652 c 3.815 -2.203 8.557 -2.203 12.371 0 l 28.262 16.317 c 3.815 2.203 6.185 6.308 6.185 10.714 v 32.635 c 0 4.406 -2.37 8.511 -6.185 10.713 L 51.185 88.348 C 49.278 89.449 47.139 90 45 90 z M 45 2 c -1.793 0 -3.586 0.462 -5.185 1.385 L 11.553 19.702 c -3.199 1.846 -5.186 5.288 -5.186 8.981 v 32.635 c 0 3.694 1.987 7.135 5.186 8.98 l 28.262 16.317 c 3.199 1.848 7.173 1.848 10.37 0 l 28.262 -16.317 c 3.199 -1.846 5.185 -5.287 5.185 -8.98 V 28.683 c 0 -3.693 -1.987 -7.134 -5.185 -8.981 L 50.185 3.385 C 48.586 2.462 46.793 2 45 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.353 58.573 c -0.339 0 -0.664 -0.174 -0.85 -0.473 L 16.746 35.935 v 21.638 c 0 0.553 -0.448 1 -1 1 s -1 -0.447 -1 -1 V 32.427 c 0 -0.447 0.296 -0.839 0.726 -0.962 c 0.429 -0.123 0.888 0.055 1.124 0.435 l 13.758 22.165 V 32.427 c 0 -0.552 0.448 -1 1 -1 c 0.552 0 1 0.448 1 1 v 25.146 c 0 0.446 -0.296 0.839 -0.726 0.962 C 31.537 58.56 31.445 58.573 31.353 58.573 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.104 58.573 c -0.552 0 -1 -0.447 -1 -1 V 32.427 c 0 -0.552 0.448 -1 1 -1 h 11.148 c 0.553 0 1 0.448 1 1 c 0 0.552 -0.447 1 -1 1 H 42.104 v 24.146 C 42.104 58.125 41.656 58.573 41.104 58.573 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.967 46 h -8.863 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 8.863 c 0.553 0 1 0.448 1 1 S 50.52 46 49.967 46 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.254 33.427 H 59.964 c -0.553 0 -1 -0.448 -1 -1 c 0 -0.552 0.447 -1 1 -1 h 14.291 c 0.553 0 1 0.448 1 1 C 75.254 32.979 74.807 33.427 74.254 33.427 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.109 58.573 c -0.553 0 -1 -0.447 -1 -1 V 32.427 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 25.146 C 68.109 58.125 67.662 58.573 67.109 58.573 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftMiningIcon);
export default __webpack_public_path__ + "static/media/nft-mining-icon.e1101d858a8d7000d2cd4073b7c73c6f.svg";
export { ForwardRef as ReactComponent };